<template>
  <div
    class="msgBox"
    @mouseleave="closeMsgBox"
    @mouseenter="openMsgBox"
  >
    <!-- @mouseenter="openMsgBox" -->
    <audio
      src="@/assets/audio/msg.mp3"
      controls="controls"
      :muted="muted"
      preload
      ref="audio"
      hidden
    ></audio>
    <msgCenter v-if="showMsgCenter"></msgCenter>
    <div
      class="msg"
      :class="$store.state.msg.hasNew&&$store.state.msg.hasMsg?'swing':''"
      @click="openMsgBox"
    >
      <div
        class="dot"
        :hidden="!$store.state.msg.hasMsg"
      ></div>
      <i class="sz szlingdangbeifen">
      </i>
    </div>
  </div>
</template>

<script>
import notifyBtn from "./notifyBtn.vue";
import msgCenter from "./msgCenter.vue";
export default {
  name: "msg",
  components: {
    msgCenter: msgCenter,
  },
  computed: {
    // hasMsg: {
    //   get () {
    //     return this.$store.state.msg.hasMsg;
    //   },
    //   set (v) {
    //     this.$store.commit("msg/set", { hasMsg: v });
    //   }
    // },
    showNoti() {
      return this.$store.getters["msg/showNoti"];
      // return this.$store.state.msg.showNoti;
    },
    audioPlay() {
      return this.$store.getters["msg/audioPlay"];
    },
    showMsgCenter() {
      this.true = false;
      return this.$store.state.msg.showMsgCenter;
    },
  },
  data() {
    return {
      muted: false,
    };
  },
  methods: {
    //鼠标经过消息图标，打开消息弹层，并取消抖动
    openMsgBox() {
      this.$notify.closeAll();
      // this.hasNew = false;
      this.$store.dispatch("msg/setShowMsgCenter", true);
      if (this.$store.state.msg.hasNew) {
        this.$store.commit("msg/setHasNew", false);
      }
    },
    closeMsgBox() {
      this.$store.commit("msg/setShowMsgCenter", false);
    },
    addNotify(msg) {
      if (this.audioPlay) {
        this.$refs.audio.currentTime = 0; //从头开始播放提示音
        this.$refs.audio.play(); //播放
      }
      this.$store.dispatch("msg/push", msg);
      if (this.showMsgCenter || !this.showNoti) {
        return;
      }
      if (msg.type == 1) {
        this.$notify({
          title: msg.title,
          message: msg.msg,
          duration: 0,
          offset: 60,
        });
      } else {
        this.$notify({
          title: msg.title,
          dangerouslyUseHTMLString: true,
          customClass: "diyNotify",
          message: this.$createElement(notifyBtn, {
            props: {
              msg: msg,
            },
          }),
          duration: 0,
          offset: 60,
        });
        // this.$notify({
        //   title: msg.title,
        //   dangerouslyUseHTMLString: true,
        //   customClass: "diyNotify",
        //   message: `<p>${msg.msg}</p><p style="text-align:center;"><span style="cursor:pointer;color:#409EFF" @click="test">点我去处理</span></p>`,
        //   duration: 0,
        //   offset: 60,
        // });
      }
    },
  },
  async mounted() {
    await this.signalr.start().then(async () => {
      console.log("已连接", this.signalr);
      await this.signalr.on("Send", (msg) => {
        console.log(msg);
        this.addNotify(msg);
      });
    });
  },
  async destroyed() {
    await this.signalr.stop();
  },
};
</script>

<style lang="scss" scoped>
.msgBox {
  float: left;
  width: 40px;
  height: 60px;
  padding-top: 10px;
  .msg {
    width: 40px;
    height: 50px;
    cursor: pointer;
    position: relative;
    i {
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
    }
    .dot {
      position: absolute;
      right: 15px;
      bottom: 14px;
      width: 8px;
      height: 8px;
      border-radius: 10px;
      background-color: #f56c6c;
    }
  }
  .msg.swing {
    //左右摆动
    @keyframes roundRule {
      0%,
      100% {
        -webkit-transform: rotate(-15deg);
      }
      50% {
        -webkit-transform: rotate(15deg);
      }
    }
    animation: roundRule 1.2s ease-in-out infinite;
    transform-origin: top center;
  }
}
</style>
<style lang="scss">
.diyNotify {
  .el-notification__group {
    width: 100%;
  }
}
</style>